import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { img, money } from "@/lib/api";
import { Reveal, Eyebrow, EASE } from "./Reveal";

const SPANS = ["md:col-span-2 md:row-span-2", "md:col-span-2", "md:col-span-1", "md:col-span-1"];

const track = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--x", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--y", `${e.clientY - r.top}px`);
};

const Tile = ({ p, i }) => (
  <motion.div
    className={`${SPANS[i]} min-h-[300px]`}
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, delay: i * 0.1, ease: EASE }}
  >
    <Link to={`/item/${p.id}`} onMouseMove={track} data-testid={`bento-tile-${i}`} className="chamfer group relative block h-full w-full overflow-hidden bg-[#110720]">
      <img src={img(p.images?.[0])} alt={p.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105" />
      <div className="spotlight absolute inset-0 opacity-60 transition-opacity duration-500 group-hover:opacity-100" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#07030c] via-[#07030c]/20 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-6 md:p-8">
        <div className="min-w-0">
          <p className={`font-display leading-tight text-[#f3eefc] ${i === 0 ? "text-3xl md:text-5xl" : "text-2xl"}`}>{p.title}</p>
        </div>
        <div className="flex shrink-0 items-center gap-3">
          <span className="font-mono-j text-[#f3eefc]">{money(p.price)}</span>
          <span className="grid h-10 w-10 place-items-center rounded-full bg-[#f3eefc] text-[#07030c] transition-transform duration-500 group-hover:rotate-45"><ArrowUpRight className="h-4 w-4" /></span>
        </div>
      </div>
    </Link>
  </motion.div>
);

export const Bento = ({ products }) => {
  const items = products.filter((p) => p.status !== "Sold").slice(0, 4);
  if (!items.length) return null;
  return (
    <section className="mx-auto max-w-[1400px] px-5 py-28 md:px-10 md:py-40" data-testid="featured-bento">
      <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <Eyebrow>Featured drops</Eyebrow>
          <h2 className="font-display mt-5 max-w-2xl text-5xl leading-[0.95] text-[#f3eefc] md:text-7xl">Pieces worth <span className="italic text-[#d8b4fe]">claiming</span> first.</h2>
        </div>
        <Link to="/shop" data-testid="bento-view-all-link" className="text-sm text-[#d8b4fe] underline-offset-8 hover:underline">View the full shop →</Link>
      </Reveal>
      <div className="grid grid-cols-1 gap-5 md:auto-rows-[300px] md:grid-cols-4">
        {items.map((p, i) => <Tile key={p.id} p={p} i={i} />)}
      </div>
    </section>
  );
};
